// extracted by mini-css-extract-plugin
export default {"wrapper":"settings_wrapper__hEIrw","content":"settings_content__S1TaF"};